import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import Layout from './components/layout/Layout'
import Dashboard from './pages/dashboard/Dashboard'
import OrganizadoresList from './pages/organizadores/OrganizadoresList'
import ImportacaoLeilao from './pages/superadmin/ImportacaoLeilao'
import ImportacaoClientes from './pages/superadmin/ImportacaoClientes'
import ImportacaoLeiloesBulk from './pages/superadmin/ImportacaoLeiloesBulk'
import SuperAdminDashboard from './pages/superadmin/SuperAdminDashboard'
import TokensExternos from './pages/superadmin/TokensExternos'
import WhatsAppConfig from './pages/superadmin/WhatsAppConfig'
import TodosLogins from './pages/superadmin/TodosLogins'
import OrganizadorDetalhes from './pages/organizadores/OrganizadorDetalhes'
import ClientesLista from './pages/clientes/ClientesLista'
import ClienteDetalhes from './pages/clientes/ClienteDetalhes'
import CadastrosPublicosLista from './pages/clientes/CadastrosPublicosLista'
import Usuarios from './pages/configuracoes/Usuarios'
import Configuracoes from './pages/configuracoes/index'
import Faturamento from './pages/configuracoes/Faturamento'
import CatalogoLeilaoConfig from './pages/configuracoes/CatalogoLeilao'
import CatalogoOnlineConfig from './pages/configuracoes/CatalogoOnline'
import CadastroPublicoConfig from './pages/configuracoes/CadastroPublico'
import IsencaoDefesaConfig from './pages/configuracoes/IsencaoDefesa'
import Leiloes from './pages/leiloes/Leiloes'
import NovoLeilao from './pages/leiloes/NovoLeilaoModerno'
import EditarLeilao from './pages/leiloes/EditarLeilaoModerno'
import DetalhesLeilao from './pages/leiloes/DetalhesLeilao'
import ComissoesLista from './pages/comissoes/ComissoesLista'
import LeiloeirosList from './pages/leiloeiros/LeiloeirosList'
import MapaCurralPage from './pages/lotes/MapaCurralPage'
import Idades from './pages/lotes/Idades'
import Racas from './pages/lotes/Racas'
import TiposAnimais from './pages/lotes/TiposAnimais'
import LotesLista from './pages/lotes/LotesLista'
import NovoLote from './pages/lotes/NovoLote'
import NovoLoteCavalo from './pages/lotes/NovoLoteCavalo'
import Login from './pages/auth/Login'
import ForgotPassword from './pages/auth/ForgotPassword'
import ResetPassword from './pages/auth/ResetPassword'
import CatalogoOnlinePage from './pages/catalogo-online/CatalogoOnlinePage'
import CadastroPublicoPage from './pages/cadastro-publico/CadastroPublicoPage'
import SystemSelector from './pages/auth/SystemSelector'
import { OrdemEntrada } from './pages/ordem-entrada'
import FiltrosAutomaticos from './pages/ordem-entrada/FiltrosAutomaticos'
import FiltrosBateriasForm from './pages/ordem-entrada/FiltrosBateriasForm'
import Justificativas from './pages/ordem-entrada/Justificativas'
import CatalogoLeilao from './pages/catalogos/CatalogoLeilao'
import CatalogoLeilaoList from './pages/catalogos/CatalogoLeilaoList'
import CatalogoPisteiro from './pages/catalogos/CatalogoPisteiro'
import CatalogoPisteiroList from './pages/catalogos/CatalogoPisteiroList'
import CatalogoDetalhado from './pages/catalogos/CatalogoDetalhado'
import CatalogoDetalhadoList from './pages/catalogos/CatalogoDetalhadoList'
import FichaLeiloeiro from './pages/catalogos/FichaLeiloeiro'
import FichaLeiloeiroList from './pages/catalogos/FichaLeiloeiroList'
import FichaCurral from './pages/catalogos/FichaCurral'
import CatalogoOnlineRedirect from './pages/catalogos/CatalogoOnlineRedirect'
import NotaCompromissoList from './pages/catalogos/NotaCompromissoList'
import CatalogoTransmissao from './pages/catalogos/CatalogoTransmissao'
import CatalogoPisteiroConfig from './pages/configuracoes/CatalogoPisteiro'
import CatalogoDetalhadoConfig from './pages/configuracoes/CatalogoDetalhado'
import FichaLeiloeiroConfig from './pages/configuracoes/FichaLeiloeiro'
import Contratos from './pages/configuracoes/Contratos'
import DadosBancarios from './pages/configuracoes/DadosBancarios'
import MapasConfig from './pages/configuracoes/Mapas'
import RelatoriosConfig from './pages/configuracoes/Relatorios'
import AuditoriaLog from './pages/configuracoes/AuditoriaLog'
import MeusDados from './pages/configuracoes/MeusDados'
import ContratoUmaVia from './pages/contratos/ContratoUmaVia'
import NotaPromissoria from './pages/contratos/NotaPromissoria'
import MapaComprador from './pages/mapas/MapaComprador'
import MapaVendedor from './pages/mapas/MapaVendedor'
import FaturaComprador from './pages/mapas/FaturaComprador'
import FaturaVendedor from './pages/mapas/FaturaVendedor'
import FaturaAcerto from './pages/mapas/FaturaAcerto'
import ListaVendedores from './pages/mapas/ListaVendedores'
import BalancoVendas from './pages/mapas/BalancoVendas'
import ComissoesCliente from './pages/mapas/ComissoesCliente'
import ComissaoLeiloeiro from './pages/mapas/ComissaoLeiloeiro'
import MapaVendedorDefesa from './pages/mapas/MapaVendedorDefesa'
import MapaGeral from './pages/mapas/MapaGeral'
import MapaGeralDefesas from './pages/mapas/MapaGeralDefesas'
import MapaGeralNaoMov from './pages/mapas/MapaGeralNaoMov'
import MapaGeralVendedores from './pages/mapas/MapaGeralVendedores'
import MapaGeralCompradores from './pages/mapas/MapaGeralCompradores'
import RankingCompradores from './pages/relatorios/RankingCompradores'
import RankingVendedores from './pages/relatorios/RankingVendedores'
import RelacaoCompradores from './pages/relatorios/RelacaoCompradores'
import RelacaoVendedores from './pages/relatorios/RelacaoVendedores'
import RelacaoVendedoresNominal from './pages/relatorios/RelacaoVendedoresNominal'
import LiberacaoCurral from './pages/relatorios/LiberacaoCurral'
import AutorizacaoGTA from './pages/relatorios/AutorizacaoGTA'
import ContratoUnificado from './pages/relatorios/ContratoUnificado'
import ListagemCompradores from './pages/relatorios/ListagemCompradores'
import EntradaAnimais from './pages/portaria/EntradaAnimais'
import SaidaAnimais from './pages/portaria/SaidaAnimais'
import RelatorioEntrada from './pages/portaria/RelatorioEntrada'
import RelatorioSaida from './pages/portaria/RelatorioSaida'
import RastreamentoVendedor from './pages/portaria/RastreamentoVendedor'
import GestaoDashboard from './pages/gestao/GestaoDashboard'
import LeilaoTempoReal from './pages/tempo-real/LeilaoTempoReal'
import RecibosPage from './pages/recibos/RecibosPage'
import GtaNotaConfig from './pages/cadastros/GtaNotaConfig'
import MotoristasList from './pages/cadastros/MotoristasList'
import Fretes from './pages/relatorios/Fretes'
import MeiosPagamentoPage from './pages/meios-pagamento/MeiosPagamentoPage'
import ContasReceber from './pages/gestao/ContasReceber'
import CreditosClientes from './pages/gestao/CreditosClientes'
import ContasPagar from './pages/gestao/ContasPagar'
import Categorias from './pages/gestao/Categorias'
import FormasPagamento from './pages/gestao/FormasPagamento'
import RelatorioContasReceber from './pages/gestao/RelatorioContasReceber'
import RelatorioContasPagar from './pages/gestao/RelatorioContasPagar'
import RelatorioGeral from './pages/gestao/RelatorioGeral'
import RelatorioCompradorVendedor from './pages/gestao/RelatorioCompradorVendedor'
import CompradorVendedor from './pages/gestao/CompradorVendedor'
import ConfiguracoesGestao from './pages/gestao/Configuracoes'
import VendedorRepasses from './pages/gestao/Vendedor'
import RelatorioRepassesVendedor from './pages/gestao/RelatorioRepassesVendedor'
import Socios from './pages/socios/Socios'
import RelatorioSocios from './pages/socios/RelatorioSocios'
import PisteirosPage from './pages/pisteiros/PisteirosPage'
import RelatorioReceitaPisteiros from './pages/relatorios/RelatorioReceitaPisteiros'
import RelatorioCarteiraPisteiros from './pages/relatorios/RelatorioCarteiraPisteiros'
import PromotoresPage from './pages/promotores/PromotoresPage'
import AssessoresPage from './pages/assessores/AssessoresPage'
import AnimaisCadastroPage from './pages/animais/AnimaisCadastroPage'
import DistribuicaoComissao from './pages/relatorios/DistribuicaoComissao'
import InteligenciaPecuaria from './pages/inteligencia/InteligenciaPecuaria'
import { useAuthStore } from './stores/authStore'
import { Toaster } from 'react-hot-toast'
import { OrganizadorProvider, useOrganizador } from './contexts/OrganizadorContext'
import { Navigate } from 'react-router-dom'
import './styles/globals.css'

const queryClient = new QueryClient()

const ACESSO_TOTAL_ROLES = ['super_admin', 'admin', 'escritorio']

function temAcessoDashboard(user) {
  if (!user) return false
  const nivel = user.permission_level
  if (ACESSO_TOTAL_ROLES.includes(nivel)) return true
  if (nivel === 'manejo') return true
  if (nivel === 'personalizado') return (user.modulos_acesso || []).includes('dashboard')
  return false
}

function getRotaInicial(user) {
  if (!user) return '/login'
  const nivel = user.permission_level
  if (nivel === 'super_admin') return '/super-admin/dashboard'
  if (ACESSO_TOTAL_ROLES.includes(nivel)) return '/dashboard'

  const temAcesso = (modulo) => {
    if (nivel === 'manejo') return ['lotes', 'clientes', 'relatorios', 'dashboard'].includes(modulo)
    if (nivel === 'personalizado') {
      const acesso = user.modulos_acesso || []
      return acesso.includes(modulo) || acesso.includes(`${modulo}-visualizar`)
    }
    return false
  }

  const FALLBACKS = [
    { modulo: 'dashboard',  path: '/dashboard' },
    { modulo: 'lotes',      path: '/lotes' },
    { modulo: 'clientes',   path: '/clientes' },
    { modulo: 'leiloes',    path: '/leiloes' },
    { modulo: 'comissoes',  path: '/comissoes' },
    { modulo: 'relatorios', path: '/relatorios/ranking-compradores' },
    { modulo: 'mapas',      path: '/mapas/mapa-geral' },
  ]

  for (const { modulo, path } of FALLBACKS) {
    if (temAcesso(modulo)) return path
  }

  return '/catalogos/transmissao'
}

function HomeRedirect() {
  const { organizadorAtivo, loading } = useOrganizador()
  const { user } = useAuthStore()
  if (loading || (!organizadorAtivo && user)) return null

  // Super admin vai direto pro painel admin
  if (user?.permission_level === 'super_admin') {
    return <Navigate to="/super-admin/dashboard" replace />
  }

  if (!temAcessoDashboard(user)) {
    return <Navigate to={getRotaInicial(user)} replace />
  }

  return <Navigate to="/dashboard" replace />
}

function SuperAdminRoute({ children }) {
  const { user } = useAuthStore()
  if (user?.permission_level !== 'super_admin') return <Navigate to={getRotaInicial(user)} replace />
  return children
}

function DashboardRoute({ children }) {
  const { user } = useAuthStore()
  if (!temAcessoDashboard(user)) return <Navigate to={getRotaInicial(user)} replace />
  return children
}

function App() {
  const { isAuthenticated } = useAuthStore()

  return (
    <QueryClientProvider client={queryClient}>
      <OrganizadorProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="min-h-screen bg-gray-50">
          <Toaster position="top-right" containerStyle={{ top: 12, right: 12 }} toastOptions={{ duration: 3000 }} />
          <Routes>
            {/* Rotas públicas */}
            <Route path="/login" element={isAuthenticated ? <HomeRedirect /> : <Login />} />
            <Route path="/esqueci-senha" element={<ForgotPassword />} />
            <Route path="/redefinir-senha" element={<ResetPassword />} />
            <Route path="/catalogo/:slug" element={<CatalogoOnlinePage />} />
            <Route path="/cadastro/:slug" element={<CadastroPublicoPage />} />
            
            {/* Rotas protegidas */}
            {isAuthenticated ? (
              <>
                <Route path="/mapa-curral" element={<MapaCurralPage />} />
                <Route path="/selector" element={<SystemSelector />} />
                <Route path="/*" element={
                  <Layout>
                    <Routes>
                      <Route path="/" element={<HomeRedirect />} />
                      <Route path="/dashboard" element={<DashboardRoute><Dashboard /></DashboardRoute>} />
                      <Route path="/organizadores" element={<SuperAdminRoute><OrganizadoresList /></SuperAdminRoute>} />
                      <Route path="/super-admin/importacao" element={<SuperAdminRoute><ImportacaoLeilao /></SuperAdminRoute>} />
                      <Route path="/super-admin/importacao-clientes" element={<SuperAdminRoute><ImportacaoClientes /></SuperAdminRoute>} />
                      <Route path="/super-admin/importacao-leiloes-bulk" element={<SuperAdminRoute><ImportacaoLeiloesBulk /></SuperAdminRoute>} />
                      <Route path="/super-admin/dashboard" element={<SuperAdminRoute><SuperAdminDashboard /></SuperAdminRoute>} />
                      <Route path="/super-admin/tokens-externos" element={<SuperAdminRoute><TokensExternos /></SuperAdminRoute>} />
                      <Route path="/super-admin/whatsapp" element={<SuperAdminRoute><WhatsAppConfig /></SuperAdminRoute>} />
                      <Route path="/super-admin/todos-logins" element={<SuperAdminRoute><TodosLogins /></SuperAdminRoute>} />
                      <Route path="/organizadores/:id/detalhes" element={<SuperAdminRoute><OrganizadorDetalhes /></SuperAdminRoute>} />
                      <Route path="/clientes" element={<ClientesLista />} />
                      <Route path="/clientes/cadastros-publicos" element={<CadastrosPublicosLista />} />
                      <Route path="/clientes/:id" element={<ClienteDetalhes />} />
                      <Route path="/leiloes" element={<Leiloes />} />
                      <Route path="/leiloes/novo" element={<NovoLeilao />} />
                      <Route path="/leiloes/:id" element={<DetalhesLeilao />} />
                      <Route path="/leiloes/:id/editar" element={<EditarLeilao />} />
                      <Route path="/lotes/novo" element={<NovoLote />} />
                      <Route path="/lotes/editar/:id" element={<NovoLote />} />
                      <Route path="/lotes/novo-cavalo" element={<NovoLoteCavalo />} />
                      <Route path="/lotes/editar-cavalo/:id" element={<NovoLoteCavalo />} />
                      <Route path="/lotes" element={<LotesLista />} />
                      <Route path="/idades" element={<Idades />} />
                      <Route path="/racas" element={<Racas />} />
                      <Route path="/tipos-animais" element={<TiposAnimais />} />
                      <Route path="/tipos-animal" element={<TiposAnimais />} />
                      <Route path="/comissoes" element={<ComissoesLista />} />
                      <Route path="/leiloeiros" element={<LeiloeirosList />} />
                      <Route path="/ordem-entrada" element={<OrdemEntrada />} />
                      <Route path="/ordem-entrada/filtros-automaticos" element={<FiltrosAutomaticos />} />
                      <Route path="/ordem-entrada/filtros-automaticos/novo" element={<FiltrosBateriasForm />} />
                      <Route path="/ordem-entrada/filtros-automaticos/:filtroId" element={<FiltrosBateriasForm />} />
                      <Route path="/ordem-entrada/justificativas" element={<Justificativas />} />
                      <Route path="/ordem-entrada/:leilaoId" element={<OrdemEntrada />} />
                      <Route path="/catalogos/leilao" element={<CatalogoLeilaoList />} />
                      <Route path="/catalogos/leilao/:leilaoId" element={<CatalogoLeilao />} />
                      <Route path="/catalogos/pisteiro" element={<CatalogoPisteiroList />} />
                      <Route path="/catalogos/pisteiro/:leilaoId" element={<CatalogoPisteiro />} />
                      <Route path="/catalogos/detalhado" element={<CatalogoDetalhadoList />} />
                      <Route path="/catalogos/detalhado/:leilaoId" element={<CatalogoDetalhado />} />
                      <Route path="/catalogos/ficha-leiloeiro" element={<FichaLeiloeiroList />} />
                      <Route path="/catalogos/ficha-curral" element={<FichaCurral />} />
                      <Route path="/catalogos/nota-compromisso" element={<NotaCompromissoList />} />
                      <Route path="/catalogos/transmissao" element={<CatalogoTransmissao />} />
                      <Route path="/catalogos/online" element={<CatalogoOnlineRedirect />} />
                      <Route path="/catalogo-leilao/:leilaoId" element={<CatalogoLeilao />} />
                      <Route path="/configuracoes" element={<Configuracoes />} />
                      <Route path="/configuracoes/faturamento" element={<Faturamento />} />
                      <Route path="/configuracoes/usuarios" element={<Usuarios />} />
                      <Route path="/configuracoes/catalogo-leilao" element={<CatalogoLeilaoConfig />} />
                      <Route path="/configuracoes/catalogo-pisteiro" element={<CatalogoPisteiroConfig />} />
                      <Route path="/configuracoes/catalogo-detalhado" element={<CatalogoDetalhadoConfig />} />
                      <Route path="/configuracoes/ficha-leiloeiro" element={<FichaLeiloeiroConfig />} />
                      <Route path="/configuracoes/contratos" element={<Contratos />} />
                      <Route path="/configuracoes/dados-bancarios" element={<DadosBancarios />} />
                      <Route path="/configuracoes/catalogo-online" element={<CatalogoOnlineConfig />} />
                      <Route path="/configuracoes/cadastro-publico" element={<CadastroPublicoConfig />} />
                      <Route path="/configuracoes/mapas" element={<MapasConfig />} />
                      <Route path="/configuracoes/relatorios" element={<RelatoriosConfig />} />
                      <Route path="/configuracoes/auditoria" element={<AuditoriaLog />} />
                      <Route path="/configuracoes/isencao-defesa" element={<IsencaoDefesaConfig />} />
                      <Route path="/configuracoes/meus-dados" element={<MeusDados />} />
                      <Route path="/contratos/uma-via/:loteId" element={<ContratoUmaVia />} />
                      <Route path="/contratos/nota-promissoria/:loteId" element={<NotaPromissoria />} />
                      <Route path="/mapas/comprador" element={<MapaComprador />} />
                      <Route path="/mapas/fatura-comprador" element={<FaturaComprador />} />
                      <Route path="/mapas/vendedor" element={<MapaVendedor />} />
                      <Route path="/mapas/fatura-vendedor" element={<FaturaVendedor />} />
                      <Route path="/mapas/fatura-acerto" element={<FaturaAcerto />} />
                      <Route path="/mapas/vendedor-defesa" element={<MapaVendedorDefesa />} />
                      <Route path="/mapas/mapa-geral" element={<MapaGeral />} />
                      <Route path="/mapas/mapa-geral-defesas" element={<MapaGeralDefesas />} />
                      <Route path="/mapas/mapa-geral-naomov" element={<MapaGeralNaoMov />} />
                      <Route path="/mapas/mapa-geral-vendedores" element={<MapaGeralVendedores />} />
                      <Route path="/mapas/mapa-geral-compradores" element={<MapaGeralCompradores />} />
                      <Route path="/relatorios/lista-vendedores" element={<ListaVendedores />} />
                      <Route path="/relatorios/balanco-vendas" element={<BalancoVendas />} />
                      <Route path="/relatorios/comissoes-cliente" element={<ComissoesCliente />} />
                      <Route path="/relatorios/comissao-leiloeiro" element={<ComissaoLeiloeiro />} />
                      <Route path="/relatorios/ranking-compradores" element={<RankingCompradores />} />
                      <Route path="/relatorios/ranking-vendedores" element={<RankingVendedores />} />
                      <Route path="/relatorios/relacao-compradores" element={<RelacaoCompradores />} />
                      <Route path="/relatorios/relacao-vendedores" element={<RelacaoVendedores />} />
                      <Route path="/relatorios/relacao-vendedores-nominal" element={<RelacaoVendedoresNominal />} />
                      <Route path="/relatorios/liberacao-curral" element={<LiberacaoCurral />} />
                      <Route path="/relatorios/fretes" element={<Fretes />} />
                      <Route path="/relatorios/autorizacao-gta" element={<AutorizacaoGTA />} />
                      <Route path="/relatorios/contrato-unificado" element={<ContratoUnificado />} />
                      <Route path="/relatorios/listagem-compradores" element={<ListagemCompradores />} />
                      <Route path="/portaria/entrada" element={<EntradaAnimais />} />
                      <Route path="/portaria/saida" element={<SaidaAnimais />} />
                      <Route path="/portaria/relatorio-entrada" element={<RelatorioEntrada />} />
                      <Route path="/portaria/relatorio-saida" element={<RelatorioSaida />} />
                      <Route path="/portaria/rastreamento" element={<RastreamentoVendedor />} />
                      {/* Gestão Financeira (Premium) */}
                      <Route path="/recibos" element={<RecibosPage />} />
                      <Route path="/cadastros/gta-nota" element={<GtaNotaConfig />} />
                      <Route path="/cadastros/motoristas" element={<MotoristasList />} />
                      <Route path="/cadastros/meios-pagamento" element={<MeiosPagamentoPage />} />
                      <Route path="/gestao" element={<GestaoDashboard />} />
                      <Route path="/gestao/dashboard" element={<GestaoDashboard />} />
                      <Route path="/gestao/contas-receber" element={<ContasReceber />} />
                      <Route path="/gestao/creditos-clientes" element={<CreditosClientes />} />
                      <Route path="/gestao/contas-pagar" element={<ContasPagar />} />
                      <Route path="/gestao/categorias" element={<Categorias />} />
                      <Route path="/gestao/formas-pagamento" element={<FormasPagamento />} />
                      <Route path="/gestao/relatorio/contas-receber" element={<RelatorioContasReceber />} />
                      <Route path="/gestao/relatorio/contas-pagar" element={<RelatorioContasPagar />} />
                      <Route path="/gestao/relatorio/geral" element={<RelatorioGeral />} />
                      <Route path="/gestao/relatorio/comprador-vendedor" element={<RelatorioCompradorVendedor />} />
                      <Route path="/gestao/comprador-vendedor" element={<CompradorVendedor />} />
                      <Route path="/gestao/configuracoes" element={<ConfiguracoesGestao />} />
                      <Route path="/gestao/vendedor" element={<VendedorRepasses />} />
                      <Route path="/gestao/relatorio/repasses-vendedor" element={<RelatorioRepassesVendedor />} />
                      {/* Gestão de Sócios (Premium) */}
                      <Route path="/socios" element={<Socios />} />
                      <Route path="/socios/relatorio" element={<RelatorioSocios />} />
                      {/* Módulo Pisteiros (Premium) */}
                      <Route path="/pisteiros" element={<PisteirosPage />} />
                      <Route path="/relatorios/receita-pisteiros" element={<RelatorioReceitaPisteiros />} />
                      <Route path="/relatorios/carteira-pisteiros" element={<RelatorioCarteiraPisteiros />} />
                      {/* Promotores */}
                      <Route path="/promotores" element={<PromotoresPage />} />
                      {/* Assessores (por lote, fluxo cavalo) */}
                      <Route path="/assessores" element={<AssessoresPage />} />
                      {/* Cadastro mestre reutilizável de animais (fluxo cavalo) */}
                      <Route path="/animais-cadastro" element={<AnimaisCadastroPage />} />
                      <Route path="/relatorios/distribuicao-comissao" element={<DistribuicaoComissao />} />
                      {/* Inteligência Pecuária (Premium) */}
                      <Route path="/inteligencia-pecuaria" element={<InteligenciaPecuaria />} />
                      {/* Leilão em Tempo Real */}
                      <Route path="/leilao-tempo-real" element={<LeilaoTempoReal />} />
                    </Routes>
                  </Layout>
                } />
              </>
            ) : (
              <Route path="*" element={<Login />} />
            )}
          </Routes>
        </div>
        </Router>
      </OrganizadorProvider>
    </QueryClientProvider>
  )
}

export default App